export type NormalizeFormFieldValuesOptions = {
  /**
   * * If true, empty values ("") will not be modified.
   * * Default: true
   */
  skipEmpty?: boolean;
};

/**
 * * Mutates form-like field values in-place by selector.
 *
 * * This is useful for uncontrolled forms that read values via `FormData`,
 * * where you want to normalize values just before submit.
 */
export function normalizeFormFieldValues(
  root: ParentNode,
  selector: string,
  normalize: (value: string) => string,
  options: NormalizeFormFieldValuesOptions = {},
) {
  const skipEmpty = options.skipEmpty ?? true;

  const fields = root.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(
    selector,
  );

  fields.forEach((field) => {
    const current = field.value;
    if (skipEmpty && current.trim() === '') return;
    const next = normalize(current);
    if (next !== current) field.value = next;
  });
}
